import React, { useState } from "react";
import {
  Button,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { UserContext } from "..";
import Authenticate from "../Logic/Auth/Auth";

import { Link } from "react-router-dom";

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const handleLogout = () => Authenticate.SignOut();
  return (
    <UserContext.Consumer>
      {value => (
        <div>
          <Navbar color="light" light expand="md">
            <NavbarBrand href="/">devangel.</NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <a className="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLSe2Xf_laNJ54lJ1ALUk1gbq2eUYFhPYEVeWgYVtOyRnNbHPmw/viewform" target="_blank">
                  Connect with Startups
                    </a>
                </NavItem>
                <NavItem> 
                  <a className="nav-link" href="https://docs.google.com/forms/d/e/1FAIpQLScIVPmDp3hWkg9d8CW2fw9zQ8Sr8cVE4yQdxh0RhgMPsa5IQw/viewform" target="_blank">
                  Connect with Investors
                  </a>
                </NavItem>
                <hr/>
                <NavItem>
                  <Link className="nav-link" color="info" to="/allproduct">
                  Crypto Hunt
                  </Link>
                </NavItem>
              </Nav>

              <Nav className="ml-auto" navbar>
                {value.role == "admin" && (
                  <NavItem>
                    <Link className="nav-link" to="/admin">
                      <Button color="primary" className="btn-sm">
                        Admin
                      </Button>
                    </Link>
                  </NavItem>
                )}
                {value !== false && (
                  <UncontrolledDropdown nav inNavbar className="pt-2">
                    <DropdownToggle nav caret className="text-capitalize">
                      {value.displayName || value.email}
                    </DropdownToggle>
                    <DropdownMenu right>
                      <Link className="dropdown-item" to="/account">
                        Profile
                      </Link>
                      <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}

                {value === false && (
                  <NavItem className="pull-right">
                    <NavLink className="pull-right" href="/login">
                      <Button color="primary" className="btn-sm pull-right">
                        Sign In
                      </Button>
                    </NavLink>
                  </NavItem>
                )}
                {value === false && (
                  <NavItem className="pull-right">
                    <NavLink href="/signup">
                      <Button
                        outline
                        color="primary"
                        className="btn-sm pull-right"
                      >
                        Sign Up
                      </Button>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Collapse>
          </Navbar>
        </div>
      )}
    </UserContext.Consumer>
  );
}
